if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', class CartUpsell extends HTMLElement {
    constructor() {
      super();
      this.carousel = null;
      this.swiper = null;
    }

    connectedCallback() {
      this.carousel = this.querySelector('#cart-upsell-carousel');
      this.prevButton = this.querySelector('.cart-upsell__arrow--prev');
      this.nextButton = this.querySelector('.cart-upsell__arrow--next');

      // Load recommendations when cart drawer opens
      this.loadRecommendations();
    }

    async loadRecommendations() {
      try {
        // Get the last item in cart to use for recommendations
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        if (!cart.items || cart.items.length === 0) {
          this.style.display = 'none';
          return;
        }

        // Get the last added item's product ID
        const lastItem = cart.items[cart.items.length - 1];
        const productId = lastItem.product_id;

        // Fetch product recommendations
        const recommendationsResponse = await fetch(
          `/recommendations/products.json?product_id=${productId}&limit=8`
        );
        const recommendations = await recommendationsResponse.json();

        if (!recommendations.products || recommendations.products.length === 0) {
          this.style.display = 'none';
          return;
        }

        // Filter out products already in cart
        const cartProductIds = cart.items.map(item => item.product_id);
        const filteredProducts = recommendations.products.filter(
          product => !cartProductIds.includes(product.id)
        );

        if (filteredProducts.length === 0) {
          this.style.display = 'none';
          return;
        }

        // Render products
        this.renderProducts(filteredProducts);

        // Initialize Swiper after products are rendered
        this.initSwiper();

      } catch (error) {
        console.error('Error loading cart upsell recommendations:', error);
        this.style.display = 'none';
      }
    }

    renderProducts(products) {
      this.carousel.innerHTML = '';
      this.carousel.classList.remove('loading');

      products.forEach(product => {
        const productCard = this.createProductCard(product);
        this.carousel.appendChild(productCard);
      });
    }

    createProductCard(product) {
      const div = document.createElement('div');
      div.className = 'swiper-slide cart-upsell__item';

      const variant = product.variants[0];
      const price = this.formatMoney(variant.price);
      const image = product.featured_image || '';

      div.innerHTML = `
        <div class="cart-upsell__item-image-wrapper">
          ${image ? `<img src="${image}" alt="${product.title}" class="cart-upsell__item-image" loading="lazy">` : ''}
        </div>
        <div class="cart-upsell__item-content">
          <h4 class="cart-upsell__item-title">${product.title}</h4>
          <div class="cart-upsell__item-footer">
            <p class="cart-upsell__item-price">${price}</p>
            <button
              type="button"
              class="cart-upsell__item-button"
              data-variant-id="${variant.id}"
              ${!variant.available ? 'disabled' : ''}
            >
              ${variant.available ? 'Add' : 'Sold Out'}
            </button>
          </div>
        </div>
      `;

      // Add click handler for Add button
      const addButton = div.querySelector('.cart-upsell__item-button');
      if (addButton && variant.available) {
        addButton.addEventListener('click', () => this.addToCart(variant.id, addButton));
      }

      return div;
    }

    async addToCart(variantId, button) {
      button.disabled = true;
      button.textContent = 'Adding...';

      try {
        const formData = {
          items: [{
            id: variantId,
            quantity: 1
          }]
        };

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          formData.sections = cartDrawer.getSectionsToRender().map(section => section.id);
          formData.sections_url = window.location.pathname;
        }

        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const result = await response.json();

        // Update cart drawer
        if (cartDrawer && result.sections) {
          cartDrawer.renderContents(result);
        }

        // Reload recommendations to exclude newly added product
        this.loadRecommendations();

      } catch (error) {
        console.error('Error adding to cart:', error);
        button.disabled = false;
        button.textContent = 'Add';
        alert('There was an error adding the product to your cart. Please try again.');
      }
    }

    initSwiper() {
      // Wait for Swiper to be available
      if (typeof Swiper === 'undefined') {
        console.error('Swiper is not loaded');
        return;
      }

      // Wrap carousel items in swiper-wrapper
      const slides = Array.from(this.carousel.children);
      this.carousel.innerHTML = '';

      const swiperWrapper = document.createElement('div');
      swiperWrapper.className = 'swiper-wrapper';
      slides.forEach(slide => swiperWrapper.appendChild(slide));
      this.carousel.appendChild(swiperWrapper);

      // Initialize Swiper
      this.swiper = new Swiper(this.carousel, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        }
      });
    }

    formatMoney(cents) {
      const money = (cents / 100).toFixed(2);
      return `$${money}`;
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  });
}
